// extracted by mini-css-extract-plugin
export default {"body":"InputText_body__Piwdt","label":"InputText_label__gdMgc","input":"InputText_input__qdVS3","input--dynamic-label":"InputText_input--dynamic-label__-GAAJ"};